<div class="py-2 pl-2 pr-8 h-full w-full flex relative" [@fadeInOut]>
  @if ((isCreationProcess$ | async) === false) {
    <rk-main-menu [class.hidden]="showAppManagerMobileWarning$ | async"></rk-main-menu>
  }
  <ng-content></ng-content>
</div>
